var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCardMinimal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 140,
    viewBox: "0 0 240 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 224,
    height: 116,
    rx: 14,
    fill: "#F4F6F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 30,
    width: 144,
    height: 92,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#355A4A",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 52,
    width: 144,
    height: 16,
    fill: "#355A4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 83,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#DDE8E2",
    stroke: "#355A4A",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 88,
    width: 44,
    height: 8,
    rx: 4,
    fill: "#355A4A",
    opacity: 0.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 88,
    width: 30,
    height: 8,
    rx: 4,
    fill: "#355A4A",
    opacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCardMinimal);
export default __webpack_public_path__ + "static/media/payment-card-minimal.8ba05e3456b00b6454993364fe5d3a49.svg";
export { ForwardRef as ReactComponent };